import { render } from "./HospModal.vue?vue&type=template&id=c18a9b5a"
import script from "./HospModal.vue?vue&type=script&lang=js"
export * from "./HospModal.vue?vue&type=script&lang=js"

import "./HospModal.vue?vue&type=style&index=0&id=c18a9b5a&lang=css"

import exportComponent from "C:\\projects\\frontend\\inso-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__